module.exports = "App.Collections.ContactURLs = Backbone.Collection.extend({\n\n  model: App.Models.ContactURL\n\n});\n"